import { Action } from '@ngrx/store';
import { QueryParamsModel } from '../../_base/crud';
import { Immunization } from '../_models/immunization.model';
import { Update } from '@ngrx/entity';

export enum ImmunizationActionTypes {
  ImmunizationOnServerCreated = '[Edit Immunization Dialog] Immunization On Server Created',
  ImmunizationCreated = '[Edit Immunization Dialog] Immunization Created',
  ImmunizationOnServerUpdated = '[Edit Immunization Dialog] Immunization On Server Updated',
  ImmunizationUpdated = '[Immunization Dialog] Immunization Updated',
  ImmunizationOnServerDeleted = '[Immunization List Page]  One Immunization On Server Deleted',
  ImmunizationDeleted = '[Immunization List Page] Immunization Deleted',
  ImmunizationPageRequested = '[Immunizations List Page] Immunizations Page Requested',
  ImmunizationPageLoaded = '[Immunizations API] Contact Immunizations Page Loaded',
  ImmunizationPageToggleLoading = '[Immunization] Immunization Loading',
  ThrowImmunizationError = '[Immunization] Throw Immunization Error',
  ClearImmunizationErrors = '[Immunization] Clear Contact Errors',
  ImmunizationActionToggleLoading = '[Immunization] Immunization Action Toggle Loading',
}

export class ImmunizationPageRequested implements Action {
  readonly type = ImmunizationActionTypes.ImmunizationPageRequested;

  constructor(public payload: { page: QueryParamsModel; entityId: number; viewContext }) {}
}

export class ImmunizationPageLoaded implements Action {
  readonly type = ImmunizationActionTypes.ImmunizationPageLoaded;

  constructor(public payload: { immunizations: Immunization[]; totalCount: number }) {}
}

export class ImmunizationOnServerCreated implements Action {
  readonly type = ImmunizationActionTypes.ImmunizationOnServerCreated;
  constructor(public payload: { immunization: Immunization; entityId: number }) {}
}

export class ImmunizationCreated implements Action {
  readonly type = ImmunizationActionTypes.ImmunizationCreated;
  constructor(public payload: { immunization: Immunization }) {}
}

export class ImmunizationOnServerUpdated implements Action {
  readonly type = ImmunizationActionTypes.ImmunizationOnServerUpdated;
  constructor(public payload: { immunization: Immunization; entityId: number }) {}
}

export class ImmunizationUpdated implements Action {
  readonly type = ImmunizationActionTypes.ImmunizationUpdated;
  constructor(public payload: { immunization: Update<Immunization> }) {}
}

export class ImmunizationOnServerDeleted implements Action {
  readonly type = ImmunizationActionTypes.ImmunizationOnServerDeleted;
  constructor(public payload: { immunization_id: number }) {}
}

export class ImmunizationDeleted implements Action {
  readonly type = ImmunizationActionTypes.ImmunizationDeleted;
  constructor(public payload: { immunization_id: number }) {}
}

export class ThrowImmunizationError implements Action {
  readonly type = ImmunizationActionTypes.ThrowImmunizationError;

  constructor(public payload: { error: any }) {}
}

export class ClearImmunizationErrors implements Action {
  readonly type = ImmunizationActionTypes.ClearImmunizationErrors;
}

export class ImmunizationPageToggleLoading implements Action {
  readonly type = ImmunizationActionTypes.ImmunizationPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class ImmunizationActionToggleLoading implements Action {
  readonly type = ImmunizationActionTypes.ImmunizationActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export type ImmunizationActions =
  | ImmunizationPageRequested
  | ImmunizationPageLoaded
  | ImmunizationOnServerCreated
  | ImmunizationOnServerUpdated
  | ImmunizationOnServerDeleted
  | ImmunizationPageToggleLoading
  | ImmunizationCreated
  | ClearImmunizationErrors
  | ThrowImmunizationError
  | ImmunizationUpdated
  | ImmunizationDeleted
  | ImmunizationActionToggleLoading;
